'use client'

import { useFormatter, useTranslations } from 'next-intl'

import { formatTaskHoursLeft } from '@/features/tasks/formatTaskHoursLeft'
import { getTaskCardCtaLabelKey } from '@/features/tasks/taskCardCta'
import { rememberTasksList } from '@/lib/tasks/tasksListReturn'

import type { TaskCardDemoRow } from '../TasksTaskCards/tasksTaskCards.constants'
import { TaskFeedCard } from './index'
import type { TaskFeedStatus } from './taskFeedCard.constants'

export type TaskFeedRowCardProps = {
  row: TaskCardDemoRow
  href: string
  onClick?: () => void
  status?: TaskFeedStatus
  showStats?: boolean
}

export function TaskFeedRowCard({
  row,
  href,
  onClick,
  status,
  showStats = true
}: TaskFeedRowCardProps) {
  const t = useTranslations('tasksPage.taskCard')
  const tTime = useTranslations('tasksPage.activeSection')
  const format = useFormatter()

  return (
    <TaskFeedCard
      href={href}
      onClick={() => {
        rememberTasksList(href)
        onClick?.()
      }}
      type={row.cta}
      typeLabel={t(getTaskCardCtaLabelKey(row.cta))}
      coverSrc={row.coverUrl}
      brandLogoSrc={row.apiBrandLogoUrl}
      brandName={row.apiBrandName ?? t('fallbackBrand')}
      title={row.apiTitle ?? t('fallbackTitle')}
      social={row.social}
      socials={row.socials}
      actionPlatforms={row.actionPlatforms}
      pointsValue={format.number(row.rewardPoints)}
      stats={
        showStats
          ? {
              timeLeftLabel: formatTaskHoursLeft(row.hoursLeft, tTime),
              participantCurrent: row.participantCurrent,
              participantLimit: row.participantLimit
            }
          : undefined
      }
      status={status}
      alsoOnLabel={t('alsoOn')}
    />
  )
}
